import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  BGColor02,
  blackColor,
  blackShade19,
  blueColor04,
  regiterSuccessCardBorder,
} from "../../../../../configs/styles/muiThemes";

function ConfirmationCard1({ qty }) {
  return (
    <Stack alignItems="center" gap="12px">
      <Box
        component="img"
        src="/./assets/image/packed-box.gif"
        width="110px"
        height="110px"
      />
      <Typography color={blackShade19} fontWeight={600} fontSize={14}>
        Do you have the products listed in the order packed({qty} Items) and ready for
        pickup?
      </Typography>
      {/* <Box
        position="relative"
        width="100%"
        display="flex"
        justifyContent="center"
      >
        <Box
          sx={{
            width: "100%",
            height: "1px",
            bgcolor: BGColor02,
            position: "absolute",
            top: "50%",
          }}
        />
        <Box
          width="35px"
          height="35px"
          borderRadius="50%"
          bgcolor={regiterSuccessCardBorder}
          color={blueColor04}
          fontSize={12}
          display="flex"
          justifyContent="center"
          alignItems="center"
          fontWeight={600}
          zIndex={1}
        >
          OR
        </Box>
      </Box>
      <Typography color={blackShade19} fontWeight={600} fontSize={14}>
        Will the package be ready in next 10 mins?
      </Typography> */}
    </Stack>
  );
}

export default ConfirmationCard1;
